module.exports = __webpack_public_path__ + "static/media/Info_background.b69b9e6a.png";